<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="crumps"
        :title="title"
        :width_class="center_width_class"
      ></CenterNavbar>

      <div
        class="componet-has-nav-bar white pt-2"
        id="promotion_view_page_top"
      >
        &nbsp;
      </div>
      <div>
        <OwnerPromtionsView :is_loading="is_loading" :is_owner_view="false" :is_in_admin_view="false" :is_in_public_view="true">
        </OwnerPromtionsView>
      </div>
    </CenterPageColumn>
    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>


<script>
import OwnerPromtionsView from "../business_owner/promotions/OwnerPromtionsView";
import ServerClient from "../../lib/ServerClient";
import Utils from "../../lib/Utils";
import page_info from "../../lib/page_info";
import Page from "../../components/Page";
import SidePageColumn from "../../components/SidePageColumn";
import FeaturedSidePromotions from "../../components/FeaturedSidePromotions";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CenterNavbar from "./../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";
import QuickSideLinks from "./../../components/QuickSideLinks";
import PromotionHeader from "./../../components/PromotionHeader";

export default {
  name: "Promotion",
  components: {
    OwnerPromtionsView,
    Page,
    SidePageColumn,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer,
    CardedSectionHeader,
    QuickSideLinks,
    PromotionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      page: "promotion_view",
      quick_links: [],
      crumps: [],
      title:  "View Promotion",
      center_width_class: page_info.center_width_class,
      label: "",
      promotion_id: 0,
      promotion: Utils.get_default_promotion(),
    };
  },
  mounted() {
    this.promotion_id = parseInt(this.$route.params.id);
    this.crumps = [
        {
        text: "Promotions",
        disabled: false,
        href: "/promotions",
      },
      {
        text: "View",
        disabled: true,
        href: "/promotions/" + this.promotion_id,
      },
    ];
    this.$emit("set-page-attributes", {
      title: "View Promotion",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/promotions/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/promotions/list/view/" + this.promotion_id,
        },
      ],
      navbar_cols: 3,
    });
  },
};
</script>


